import BaseApiAction from '@Actions/base-api-action';

export default class GetClubSubscriptions extends BaseApiAction {
  runAction() {
    super.invokeCloudFunction({
      name: 'subscriptions-getClubSubscriptions',
      payload: { ...this._payload },
    });
  }
}
